// extracted by mini-css-extract-plugin
export default {"rating":"KK-z","numberOfStars":"LK-z","count":"MK-z","barGraphSpacing":"NK-z","barGraph":"OK-z"};